module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-address-form__form-group-item"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.$parent.form[_vm.$parent.address].numberEmployees),
      expression: "$parent.form[$parent.address].numberEmployees",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.$parent.$v.form[_vm.$parent.address].numberEmployees.$error
    },
    attrs: {
      "type": "text",
      "name": "employees-count"
    },
    domProps: {
      "value": (_vm.$parent.form[_vm.$parent.address].numberEmployees)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$parent.form[_vm.$parent.address], "numberEmployees", $event.target.value.trim())
      }, function($event) {
        _vm.$parent.$v.form[_vm.$parent.address].numberEmployees.$touch()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "employees-count"
    }
  }, [_c('span', {
    staticClass: "label-text"
  }, [_vm._v("\n            Anzahl Mitarbeitende\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "required-symbol"
  }, [_c('span', {
    staticClass: "sr-only",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("(Pflichtfeld)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3063bf0d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/Forms/Fields/NumberEmployees.vue
// module id = 894
// module chunks = 0